<template>
  <div class="view project-results" v-if="project">
    <project-results :project="project"></project-results>
  </div>
  <div class="view error" v-else-if="error">
    {{error}}
  </div>
</template>

<script>
import ProjectResults from '@/components/project/ProjectResults'

export default {
  name: 'SubjectResultsView',
  components: {
    ProjectResults
  },
  computed: {
    project () {
      return this.$store.state.paramsData.project
    },
    error () {
      return this.$store.state.paramsData.error
    },
  }
}
</script>

<style lang="stylus" scoped>
// .subject-results
  // display: flex
  // overflow visible !important //Para el tooltip del ECG (parace que ok...)
</style>
